import React, { useCallback } from "react";
import { Stepper } from "uikit";

const ImprovedStepper: React.FC<ImprovedStepper.Props> = ({
	value = 0,
	onChange,
	min = 0,
	disabled,
	...props
}) => {
	const newOnchange = useCallback(
		(val) => {
			onChange?.(val);
		},
		[onChange],
	);

	return (
		<Stepper
			disabled={disabled}
			value={value}
			onChange={newOnchange}
			{...props}
			min={min}
		/>
	);
};

declare namespace ImprovedStepper {
	interface Props extends Stepper.Props {
		value?: number;
		onChange?: (value: number) => void;
		disabled?: boolean;
	}
}

export default ImprovedStepper;
